import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';

import { cn } from '../lib/utils';

export type PopoverProps = React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Root> & {};

export function PopoverRoot({ ...props }: PopoverProps) {
    return (
        <PopoverPrimitive.Root {...props} />
    );
}

export type PopoverTriggerProps = React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Trigger> & {};

export function PopoverTrigger({ className, ...props }: PopoverTriggerProps) {
    return (
        <PopoverPrimitive.Trigger {...props} />
    );
}

export type PopoverContentProps = React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    ref?: React.RefObject<React.ComponentRef<typeof PopoverPrimitive.Content> | null>;
    matchTriggerWidth?: boolean;
};

export function PopoverContent({ ref, className, align = 'center', sideOffset = 4, matchTriggerWidth, ...props }: PopoverContentProps) {
    return (
        <PopoverPrimitive.Portal container={document.body}>
            <PopoverPrimitive.Content
                ref={ref}
                align={align}
                sideOffset={sideOffset}
                className={cn(
                    'z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
                    matchTriggerWidth && 'w-[var(--radix-popover-trigger-width)] max-h-[var(--radix-popover-content-available-height)]',
                    className,
                )}
                {...props}
            />
        </PopoverPrimitive.Portal>
    );
}

export const Popover = Object.assign(PopoverRoot, {
    Content: PopoverContent,
});
